<template>
  <b-card>
    <div class="d-flex align-items-center">
      <b-button variant="outline" @click="$router.push({ path: '/couriers-catalog', query: { country: countryId } })">
        <feather-icon icon="ChevronLeftIcon" size="30"/>
      </b-button>
      <img v-if="service_type" :src="`/icon/${service_type}.svg`" width="40" height="48" v-b-tooltip.hover :title="capitalizeFirstLetter(service_type)" />
      <span v-if="service_name" class="ml-1 service-name-title">{{ capitalizeFirstLetter(service_name) }}</span>
    </div>
    <template v-if="!showTable">
      <b-row class="justify-content-center mt-4 pt-4">
        <b-col v-for="index in 4" :key="index" class="col-12 col-md-3 mt-1">
          <b-skeleton class="m-1 p-1" />
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="index in 4" :key="index" class="col-12 col-md-3 mt-1">
          <b-skeleton v-for="i in 3" :key="i" class="m-1 p-1" />
        </b-col>
      </b-row>
    </template>
    <TableCouriersComparator v-if="showTable" :data="dataTable" ref="tableCouriersComparator"/>
  </b-card>
</template>

<script>
import BaseServices from '@/store/services/index'
import TableCouriersComparator from './TableCouriersComparator.vue'

export default {
  name: 'CouriersComparator',
  components: { TableCouriersComparator },
  data() {
    return {
      baseService: new BaseServices(this),
      showTable: false,
      dataTable: {},
      service_name: null,
      service_type: null,
      countryId: null
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.showTable = false
      const { country_id, service_name, service_type } = this.$route.query
      this.countryId = country_id
      this.service_name = service_name
      this.service_type = service_type
      const params = { country_id }
      const queryParams = this.$route.query
      const couriers = await this.getQueryCatalog(params, queryParams)
      const services = await this.getServices(couriers)
      this.getDataTable(services)

    },
    getDataTable(services) {
      const allPromises = services.map(service =>
        this.baseService.callService(service.name, service.queryParams, service.params)
          .then(response => {
            response.data.service = {
              id: service.queryParams['category_ids[]'],
              name: service.queryParams['service_name'],
              code: service.queryParams['service_code']
            }
            return response
          })
          .catch(err => {
            this.$newError('Ha ocurrido un problema', err.msg, 'large')
            return null // Evita que la promesa se rechace y permite manejar errores
          })
      )
      Promise.all(allPromises).then(responses => {
        const resp = responses.filter(response => response !== null)
        resp.forEach(response => {
          response.data.categories.map(category => {
            const key = Object.keys(category).find(el => el !== 'service_name')
            category[key].max_packages_boolean = !!(category[key]?.multipack === 'true')
            category[key].max_packages = (!isNaN(category[key]?.max_packages) && Number(category[key]?.max_packages) > 0) ? category[key].max_packages : null
            category[key].cut_schedule = category[key]?.court_hours || category[key]?.court_day ? `${category[key]?.court_hours ? category[key]?.court_hours : ''} ${category[key]?.court_day ? category[key]?.court_day : ''}` : '--'
            category[key].additional_insurance_cap = category[key]?.additional_safe_stop ? `${category[key]?.additional_safe_stop} ${category[key]?.additional_safe_stop_currency}` : null
            return {...category}
          })
        })
        this.dataTable = resp
        this.showTable = true
      })
    },
    getServices(couriers) {
      return couriers.flatMap(courier => {
        return courier.services.map(service => {
          return {
            name: 'getCourierServicesDetails',
            params: { carrier_id: courier.carrier_id },
            queryParams: { 'category_ids[]': service.service_id, 'service_code': service.service_code, 'service_name': service.service_name}
          }
        })
      })
    },
    getQueryCatalog(params, queryParams) {
      return this.baseService.callService('getCourierCatalog', queryParams, params)
        .then(response => {
          return response.data
        })
        .catch(err => {
          this.$newError('Ha ocurrido un problema', err.msg, 'large')
        })
    },
    capitalizeFirstLetter(str) {
      if (!str) return ''
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
  }
}
</script>
<style scoped>
  .service-name-title {
    font-size: 24px;
    font-weight: 600;
    color: #044389;
  }
</style>